<div class="static-files-page">
  <div class="page-header">
    <h2 class="page-title">Statik Dosyalar</h2>
    <lib-button variant="primary" (buttonClick)="openUploadDialog()">
      <span class="btn-content">
        <svg lucidePlus [size]="16" [strokeWidth]="2.25" aria-hidden="true"></svg>
        Dosya Ekle
      </span>
    </lib-button>
  </div>

  @if (loading()) {
    <div class="loading-overlay">
      <div class="spinner"></div>
      <p>Yükleniyor...</p>
    </div>
  } @else {
    <div class="table-wrapper">
      <table class="data-table files-table">
        <thead>
          <tr>
            <th class="action-col">
              <div class="row-actions">
                <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="loadFiles()" title="Yenile">
                  <svg lucideRefreshCw [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                </lib-button>
              </div>
            </th>
            <th>Dosya Adı</th>
            <th>Tür</th>
            <th>Güncelleme Tarihi</th>
            <th>Statik</th>
            <th>Aktif</th>
          </tr>
        </thead>
        <tbody>
          @if (items().length === 0) {
            <tr>
              <td colspan="6" class="empty-row">Kayıt bulunamadı</td>
            </tr>
          }
          @for (item of items(); track item.id) {
            <tr [class.inactive-row]="!item.isActive">
              <td class="action-col">
                <div class="row-actions">
                  @if (!item.isActive) {
                    <lib-button
                      variant="text"
                      size="sm"
                      class="portal-icon-btn portal-icon-btn--danger"
                      (buttonClick)="deleteFile(item)"
                      title="Sil"
                    >
                      <svg lucideTrash2 [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                    </lib-button>
                  }
                </div>
              </td>
              <td>
                @if (item.fileUrl && item.fileUrl.length > 0) {
                  <a [href]="item.fileUrl[0]" target="_blank" class="file-link">
                    {{ item.description }}{{ item.code ? '.' + item.code : '' }}
                  </a>
                } @else {
                  {{ item.description }}{{ item.code ? '.' + item.code : '' }}
                }
              </td>
              <td>{{ getTypeName(item.type) }}</td>
              <td>{{ item.modifiedOn ? (item.modifiedOn | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
              <td>
                <span class="badge" [class.badge-yes]="item.isStatic" [class.badge-no]="!item.isStatic">
                  {{ item.isStatic ? 'Evet' : 'Hayır' }}
                </span>
              </td>
              <td>
                <span class="badge" [class.badge-yes]="item.isActive" [class.badge-no]="!item.isActive">
                  {{ item.isActive ? 'Aktif' : 'Pasif' }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

@if (showDialog()) {
  <div class="dialog-backdrop" (click)="closeDialog()"></div>
  <div class="dialog">
    <div class="dialog-header">
      <h3>Dosya Ekle</h3>
      <button type="button" class="dialog-close" (click)="closeDialog()" aria-label="Kapat">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>

    <div class="dialog-body">
      <div class="form-field">
        <label class="field-label">Dosyalar</label>
        <input
          #fileInput
          type="file"
          class="file-input"
          accept=".js,.wasm"
          multiple
          (change)="onFileChange($event)"
        />
        <p class="field-hint">
          Birden fazla .js / .wasm seçebilirsiniz. Tür dosya adından otomatik algılanır
          (crown, veneer, bar, viewer).
        </p>
      </div>

      @if (selectedFiles().length > 0) {
        <ul class="selected-files">
          @for (item of selectedFiles(); track item.file.name; let i = $index) {
            <li class="selected-file" [class.unrecognized]="item.type == null">
              <div class="selected-file-meta">
                <span class="file-name">{{ item.file.name }}</span>
                <span class="file-type-badge" [class.file-type-badge--error]="item.type == null">
                  {{ item.typeLabel }}
                </span>
              </div>
              <button type="button" class="clear-btn" (click)="removeFile(i)">Kaldır</button>
            </li>
          }
        </ul>
        @if (hasUnrecognized()) {
          <p class="field-hint field-hint--error">
            Tanınmayan dosyalar var. Adında crown, veneer, bar veya viewer geçmeli.
          </p>
        }
        <button type="button" class="clear-all-btn" (click)="clearFiles()">Tümünü temizle</button>
      }
    </div>

    <div class="dialog-footer">
      <lib-button variant="outline" (buttonClick)="closeDialog()">İptal</lib-button>
      <lib-button
        variant="primary"
        [disabled]="!canUpload() || uploading()"
        (buttonClick)="upload()"
      >
        {{ uploading() ? 'Yükleniyor...' : selectedFiles().length > 1 ? selectedFiles().length + ' Dosya Yükle' : 'Yükle' }}
      </lib-button>
    </div>
  </div>
}
